import React, { useState, useEffect } from "react";

const _KEY = "----"

const SpeechInput = () => {
  const [transcript, setTranscript] = useState("");
  const [isListening, setIsListening] = useState(false);
  const [isSending, setIsSending] = useState(false); // Track whether request is being sent
  const [mediaRecorder, setMediaRecorder] = useState(null); // Keep track of MediaRecorder instance
  const [audioChunks, setAudioChunks] = useState([]); // Store recorded audio chunks


  const handleAudioUpload = async (audioBlob) => {
    setIsSending(true);

    const arsenalPlayers = [
      "Bukayo Saka",
      "Gabriel Jesus",
      "Martin Ødegaard",
      "Aaron Ramsdale",
      "William Saliba",
      "Gabriel Magalhães",
      "Ben White",
      "Thomas Partey",
      "Granit Xhaka",
      "Leandro Trossard",
      "Eddie Nketiah",
      "Kai Havertz",
      "Riccardo Calafiori",
      "Mikel Merino",
      "Ethan Nwaneri",
      "Raheem Sterling",
      "Declan Rice",
      "Gabriel Martinelli",
    ];

    const playerListPrompt = `The following are Arsenal players: ${arsenalPlayers.join(
    ", "
  )}. Please transcribe the name of the player mentioned, ONLY respond with full name or None if not found`;


    const formData = new FormData();
    formData.append("file", audioBlob);
    formData.append("model", "whisper-1");
    formData.append("language", "en"); // Restrict transcription to English
    formData.append("prompt", playerListPrompt);

    // List of Arsenal players

    try {
    const response = await fetch(
      "https://api.openai.com/v1/audio/transcriptions",
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${_KEY}`,
        },
        body: formData,
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    const transcript = data.text;

    // Display the AI's transcription
    setTranscript(transcript);
  } catch (error) {
    console.error("Error transcribing audio:", error);
    setTranscript("Error: Unable to process request.");
  } finally {
    setIsSending(false); // Stop indicating request after completion
  }
  };


  const startListening = async () => {
    setIsListening(true);

    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    const recorder = new MediaRecorder(stream);
    setMediaRecorder(recorder);

    const chunks = [];
    recorder.ondataavailable = (event) => {
      chunks.push(event.data);
    };

    setAudioChunks(chunks);

    recorder.start();
  };

  const stopListening = () => {
    if (mediaRecorder) {
      mediaRecorder.stop();
      mediaRecorder.onstop = () => {
        const audioBlob = new Blob(audioChunks, { type: "audio/wav" });
        handleAudioUpload(audioBlob); // Immediately send the request
        setIsListening(false);
      };
    }
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
    // Detect the 'L' key
    if (event.key === "l" && !isListening) {
      event.preventDefault();
      startListening();
      }
    };

    const handleKeyUp = (event) => {
    // Detect the 'L' key
    if (event.key === "l" && isListening) {
      event.preventDefault();
      stopListening();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("keyup", handleKeyUp);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("keyup", handleKeyUp);
    };
  }, [isListening, mediaRecorder, audioChunks]); // Dependencies to ensure proper cleanup

  return (
    <div style={{ padding: "40px", textAlign: "center" }}>
      <p>New - Press and hold the <b>L</b> to speak, then release to send.</p>
      <p>
        <strong>Status:</strong>{" "}
        {isListening
          ? "Listening..."
          : isSending
          ? "Sending request to OpenAI..."
          : "Idle"}
      </p>
      <p>Transcript: {transcript}</p>
    </div>
  );
};

export default SpeechInput;
